/** @jsx jsx */
import { jsx } from '@emotion/react';

import { token } from '@atlaskit/tokens';

/**
 * __Collapsing top margin__.
 *
 * A wrapper that adds a collapsing top margin to the first element of a list.
 *
 */
const CollapsingTopMargin = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      css={{
        margin: `${token('space.150', '12px')} 0 0 0`,
        '&:first-child': {
          marginTop: 0,
        },
      }}
    >
      {children}
    </div>
  );
};

export default CollapsingTopMargin;
